import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TextButtonProps } from '@bl/components';
import { BlFrontendBaseComponent } from './bl-frontend-base.component';

@Component({
  selector: 'bl-frontend-textbutton',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class BlFrontendTextButtonComponent extends BlFrontendBaseComponent<TextButtonProps> {
  @Input() text: TextButtonProps['text'] = '';
  @Input() variant: TextButtonProps['variant'] = 'primary';
  @Input() disabled: TextButtonProps['disabled'] = false;
  @Input() icon: TextButtonProps['icon'];
  @Input() iconSize: TextButtonProps['iconSize'];
  @Input() iconVariant: TextButtonProps['iconVariant'];

  @Output() onclick = new EventEmitter<MouseEvent>();
  @Output() onfocus = new EventEmitter<MouseEvent>();
  @Output() onblur = new EventEmitter<MouseEvent>();

  protected override getComponentName(): string {
    return 'TextButton';
  }

  protected override getProps(): TextButtonProps {
    return {
      text: this.text,
      variant: this.variant,
      disabled: this.disabled,
      icon: this.icon,
      iconSize: this.iconSize,
      iconVariant: this.iconVariant,
      onclick: (event: MouseEvent) => this.onclick.emit(event),
      onfocus: (event: MouseEvent) => this.onfocus.emit(event),
      onblur: (event: MouseEvent) => this.onblur.emit(event),
    };
  }
}
